module.exports = __webpack_public_path__ + "static/media/arm.a9e48eb6.png";